import React, { useEffect, useState } from "react";
import { Button, Input, Label, ButtonGroup } from 'reactstrap';
import { imprezyService } from "../service/Imprezy";
import MainLoader from "../components/MainLoader";
import ImprezaSimple from "../components/ImprezaSimple";
import Ranga from "../enums/Ranga";
import { getFromQuery } from "../utilities";

const Imprezy = () => {
  const [imprezy, setImprezy] = useState([]);
  const [filteredImprezy, setFilteredImprezy] = useState([]);
  const [kalendarzPdfUrl, setKalendarzPdfUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const today = new Date();
  const sezon = getFromQuery('sezon') ?? today.getFullYear();
  const [rangaFilter, setRangaFilter] = useState('');
  const [incoming, setIncoming] = useState(false);

  const fetchData = () => {
    setLoading(true);
    imprezyService.getList(sezon).then((response) => {
      setImprezy((response?.data ?? []).sort((a,b) => a.TerminOd > b.TerminOd ? 1 : -1));
      setLoading(false);
    });
    imprezyService.getKalendarzPdfUrl(sezon).then((response) => {
      setKalendarzPdfUrl(response?.data);
    }).catch(() => {
      setKalendarzPdfUrl('');
    });
  }

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    let tempImprezy = [...imprezy];
    if (incoming){
      tempImprezy = imprezy.filter(x => x.TerminOd > today)
    }
    rangaFilter
     ? setFilteredImprezy(tempImprezy.filter(x => x.Rangi.indexOf(rangaFilter) !== -1))
     : setFilteredImprezy(tempImprezy);
  }, [imprezy.length, rangaFilter, incoming])

  if (loading) return <MainLoader />;

  return (
    <>
      {/* <div className="inline-container">
        <Label for="sezon">
          Sezon
        </Label>
        <Input
          style={{maxWidth: '100px'}}
          type="number"
          value={sezon}
          name="sezon"
          onChange={(e) => setSezon(e.target.value)}
        />
        <Button
          disabled={!sezon}
          color="primary"
          className="mb-6"
          size="md"
          type="button"
          onClick={fetchData}
        >
          Szukaj
        </Button>
      </div> */}
      <div className="inline-container">
          Kalendarz w formacie PDF {kalendarzPdfUrl && <a href={kalendarzPdfUrl} target="_blank" rel="noopener noreferrer" className="ino-link"><i className="fa fa-file-pdf-o fa-2x" title="kalendarz"></i></a>}
      </div>
      <div className="inline-container">
        <Label for="filtry">
          Pokaż tylko
        </Label>
        <ButtonGroup>
          <Button
            color="success"
            outline
            onClick={() => setRangaFilter(Ranga.MP.key)}
            active={rangaFilter == Ranga.MP.key}
          >
            {Ranga.MP.value}
          </Button>
          <Button
            color="success"
            outline
            onClick={() => setRangaFilter(Ranga.PP.key)}
            active={rangaFilter == Ranga.PP.key}
          >
            {Ranga.PP.value}
          </Button>
          <Button
            color="success"
            outline
            onClick={() => setRangaFilter(Ranga.PPM.key)}
            active={rangaFilter == Ranga.PPM.key}
          >
            {Ranga.PPM.value}
          </Button>
          <Button
            color="success"
            outline
            onClick={() => setRangaFilter('')}
            active={!rangaFilter}
          >
            Wszystkie
          </Button>
        </ButtonGroup>
      </div>
      {(!filteredImprezy || !filteredImprezy.length) && <div>Brak imprez spełniających kryteria</div>}
      {filteredImprezy && filteredImprezy.length > 0 && (
        <div className="grid-container my-2">
          {filteredImprezy.map((ino) => (
            <ImprezaSimple key={ino.Id} ino={ino}/>
          ))}
        </div>
      )}
    </>
  );
} 
export default Imprezy;
